/**************************************************************************************************/
/*   File: /src/app/stores/actions/authorization/authorization.actions.ts                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday February 20th 2019                                                   */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';

/**
 * The authorization action types enum
 */
export enum AuthorizationActionTypes {
  /**
   * The check authorization status action's identifier
   */
  CHECK_AUTHORIZATION_STATUS = '[Authorization] Check Authorization',
  /**
   * The check authorization status success action's identifier
   */
  CHECK_AUTHORIZATION_STATUS_SUCCESS = '[Authorization] Check Authorization Success',
  /**
   * The check authorization status fail action's identifier
   */
  CHECK_AUTHORIZATION_STATUS_FAIL = '[Authorization] Check Authorization Fail',
  /**
   * The send authorization action's identifier
   */
  SEND_AUTHORIZATION = '[Authorization] Send authorization',
  /**
   * The send authorization success action's identifier
   */
  SEND_AUTHORIZATION_SUCCESS = '[Authorization] Send authorization success',
  /**
   * The send authorization fail action's identifier
   */
  SEND_AUTHORIZATION_FAIL = '[Authorization] Send authorization fail'
}
/**
 * This action permit to check the authorization status
 */
export class CheckAuthorizationStatus implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.CHECK_AUTHORIZATION_STATUS;

  /**
   * The constructor of check authorization
   */
  constructor() { }
}
/**
 * This action is sent when the action of check authorization has been done with success, 
 * without http error
 */
export class CheckAuthorizationStatusSuccess implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.CHECK_AUTHORIZATION_STATUS_SUCCESS;

  /**
   * The constructor of request check authorization success
   * @param payload containing the authorization status
   */
  constructor(public payload: { authorizationStatus: fromShared.models.AuthorizationStatus}) {
  }
}
/**
 * This action is sent when the check authorization fail, for http error
 */
export class CheckAuthorizationStatusFail implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.CHECK_AUTHORIZATION_STATUS_FAIL;

  /**
   * The constructor of request authorization fail
   * @param payload The payload is the one returned by the server
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}
/**
 * Action dispatched when user request the authorization
 * to newplan backend for accessing to portal functionalities
 */
export class SendAuthorization implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.SEND_AUTHORIZATION;

  /**
   * The constructor of send authorization action
   * @param payload The payload is the authorization requests
   */
  constructor(public payload: { documentId: fromShared.models.LocalDocumentId }) {
  }
}
/**
 * Action dispatched when authorization is sent and is stored by the backend
 */
export class SendAuthorizationSuccess implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.SEND_AUTHORIZATION_SUCCESS;

  /**
   * The constructor of send authorization success action
   * @param payload The payload is the message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}
/**
 * Action dispatched when send authorization cannot be stored by the backend
 */
export class SendAuthorizationFail implements Action {
  /**
   * The type
   */
  readonly type = AuthorizationActionTypes.SEND_AUTHORIZATION_FAIL;

  /**
   * The constructor of send authorization fail action
   * @param payload The payload is the message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}

/**
 * The auth actions
 */
export type AuthActions =
  CheckAuthorizationStatus |
  CheckAuthorizationStatusSuccess |
  CheckAuthorizationStatusFail |
  SendAuthorization |
  SendAuthorizationSuccess |
  SendAuthorizationFail;
